import { ItemCard } from '../../../components/atoms/ItemCard';
import { ItemCardField } from '../../../components/atoms/ItemCardField';
import { CloneEntityButton } from '../../../components/molecules/CloneEntityButton';
import { ProductInList } from '../../../interfaces/product.interface';
import { PATHS } from '../../../navigation/data';

interface Props {
  index: number;
  data: ProductInList;
}

export const ProductItemCard = ({ index, data }: Props) => {
  return (
    <div className="width-100 itemOfList positionRelative">
      <ItemCard routerLink={`${PATHS.PRODUCTS}/view/${data.id}`} entityId={data.internalSerial} index={index}>
        <div className="flex-space-between-center-row-wrap width-100">
          <ItemCardField classes="margin-r-24 width-1line" width="width-100" value={data?.name} />
        </div>
      </ItemCard>
      <CloneEntityButton index={index} data={{ id: data.id }} path={PATHS.CLONE_PRODUCT} />
    </div>
  );
};
